/* global AFRAME */

/**
 * Component that listens to an event, fades out an entity, swaps the texture, and fades it
 * back in.
 */
 
var scene;
var vid;
var vid2;
var enterVRButton;
 
AFRAME.registerComponent('play-video', {
  schema: {
	  on: {type: 'string'},
    target: {type: 'selector'},
    src: {type: 'string'},
    dur: {type: 'number', default: 300}
  },
  
  
  init: function () {
	  
	scene = document.querySelector("a-scene");
    vid = document.getElementById("video");
	vid2 = document.getElementById("videoIntro");
	
	console.log('Impossible is nothing');
	
	if (scene.hasLoaded) 
	{
		runIntro();
	} else 
	{
		scene.addEventListener("loaded", runIntro);
	}

	vid2.addEventListener("ended", run);

    function runIntro () {
		if(scene.isMobile)
		{
			addListener ();
		}else
		{ 
			vid.play();vid.pause();vid2.play();
		}	
	}
	
	function run () 
	{
		document.getElementById("introscene").setAttribute('visible', false);
		document.getElementById("mainscene").setAttribute('visible', true);
		vid.play();
		
		var entity = document.createElement('a-cursor');
		document.getElementById("camobject").appendChild(entity);
		entity.setAttribute('position', { x: 0, y: 0, z: -1.5 });
	    entity.setAttribute('fuse', 'true');
		entity.setAttribute('raycaster', {objects: ".raycastreciever"});
	}
	
	function addListener () 
	{
		document.getElementById("introMessage").setAttribute('visible', true);
		document.querySelector('body').addEventListener('click', handleFirstClick);
	}

    function handleFirstClick () 
	{
	  document.getElementById("introMessage").setAttribute('visible', false);
      vid.play();
	  vid.pause();
	  vid2.play();
	  vid2.pause();
	  
	  setTimeout(playThis, 2000);
	  
      removeHandleFirstClick();
    }
	
	function playThis() {
		vid2.play();
	}
	
	function ResetVideoForIOS(){
		
		if(document.getElementById("introscene").getAttribute('visible') == true && vid2.paused == true){
			vid2.play();
		}else if(document.getElementById("mainscene").getAttribute('visible') && vid.paused){
			vid.play();
		}
	}


    function removeHandleFirstClick () 
	{
      document.querySelector('body').removeEventListener('click', handleFirstClick);
	  document.querySelector('body').addEventListener('click', ResetVideoForIOS);
    }  
}
  
});